import { type GestureResponderEvent, Platform, Text } from 'react-native'
import { useLogError } from '@/src/common/hooks/useLogError'
import { NetworkStatus } from '@apollo/client'
import { useLoggedInQuery } from '@/src/common/gql/MesaGql'
import { GET_LINKED_EXTERNAL_ACCOUNTS } from '@/src/common/gql/queries/card'
import { ChecklistItem } from '@/src/common/modules/OnboardingChecklist/ChecklistItem'
import { styles } from '@/src/common/modules/OnboardingChecklist/styles'
import { useRefetchQueryOnFocus } from '@/src/common/hooks/useRefetchQueryOnFocus'
import { router } from 'expo-router'

export function useMesaCardPlaidChecklistItem() {
  const onError = useLogError()

  const { data: linkedExternalAccounts, networkStatus } = useRefetchQueryOnFocus(
    useLoggedInQuery(GET_LINKED_EXTERNAL_ACCOUNTS, {
      fetchPolicy: 'cache-and-network',
      onError,
    }),
  )

  if (networkStatus === NetworkStatus.loading) return 'loading'

  const hasPaymentMethod = Boolean(
    linkedExternalAccounts?.getLinkedExternalBankAccounts.accounts.length,
  )
  const paymentMethodAccountName =
    linkedExternalAccounts?.getLinkedExternalBankAccounts.accounts[0]?.accountName
  const showDetailsView = Boolean(paymentMethodAccountName)

  return hasPaymentMethod ? null : (
    <ChecklistItem
      title="Setup Payment Method"
      description="Connect the bank account you'll use to pay your Mesa Card."
      status="incomplete"
      linkProps={{ href: '/main/card/card-management/accounts' }}
      {...Platform.select({
        // expo-router isn't respecting `initialRouteName` and i'm too lazy right now to find out why
        default: {
          onPress(e: GestureResponderEvent) {
            e.preventDefault()
            router.push('/main/card/card-management')
            setTimeout(() => router.push('/main/card/card-management/accounts'), 888)
          },
        },
        // modals from which you can see parent screens beneath the modals aren't natively supported on android, so we don't need to use the workaround
        android: undefined,
      })}
    >
      {showDetailsView && <Text style={styles.subtitle}>Linked to {paymentMethodAccountName}</Text>}
    </ChecklistItem>
  )
}
